import React from 'react';
import axios from 'axios';
import {GET_EXPLOITATIONS, GET_ROLES} from "../../api/Api";

export default function useExploitationData(){

    const [isLoading,setIsLoading] = React.useState(false);
    const [roles,setRoles] = React.useState([]);

    React.useEffect(
        () => {

            setIsLoading(true)

            axios
                .get(
                    GET_ROLES
                ).then(
                ({data}) => {

                     setRoles(data);

                }
            ).finally(
                ()=>{
                    setIsLoading(false);
                }
            )

        }, []
    );

    return [isLoading,roles]
}